import styled from 'styled-components'

const defaultHeight = '6.75rem' // 108px

export const Wrapper = styled.a`
  height: ${defaultHeight};
  transition: 0.2s background-color;

  &:hover {
    background-color: var(--gray-200) !important;
  }
`

Wrapper.displayName = 'Wrapper'

export const ImageWrapper = styled.div`
  width: ${defaultHeight};
  height: ${defaultHeight};

  img {
    object-fit: cover;
  }
`

ImageWrapper.displayName = 'ImageWrapper'

export const Label = styled.span`
  border: 1px solid var(--green);
  background-color: var(--green-darkest);
  column-gap: var(--spacer-1);
  min-height: 1.5rem;
  line-height: 1.1;
`

Label.displayName = 'Label'
